import React from 'react'
import Layout from './src/components/Layout/Layout'

// eslint-disable-next-line react/display-name,react/prop-types
export default ({ element, props }): React.ReactElement => {
  return <Layout {...props}>{element}</Layout>
}
